<script lang="ts">
	import SubUnitManagementV2 from 'src/components/Settings/HomeManagement/SubUnitManagementV2.svelte';
</script>

<SubUnitManagementV2 />
